import { useEffect, useRef, useState } from 'react';

export default function useDashboardRequest() {
  const latestRequest = useRef(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => () => {
    latestRequest.current += 1;
  }, []);

  const runRequest = async (fetchResponse, onSuccess) => {
    latestRequest.current += 1;
    const requestId = latestRequest.current;
    setLoading(true);
    setError(false);
    try {
      const response = await fetchResponse();
      if (requestId === latestRequest.current) onSuccess(response);
    } catch (requestError) {
      if (requestId === latestRequest.current) setError(true);
    } finally {
      if (requestId === latestRequest.current) setLoading(false);
    }
  };

  return { loading, error, runRequest };
}